export default "/imgs/investigation-07.png"